module.exports = __webpack_public_path__ + "themes/fq/img/button@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/button@2x.png
// module id = 58
// module chunks = d-game